import { Controller } from "@hotwired/stimulus"

// Replaces inline `onclick="document.getElementById('foo').classList.add('hidden')"` etc.
// so CSP can drop `'unsafe-inline'` from script-src.
//
// Apply via `data-controller="modal-toggle"` (typically on the trigger or modal itself)
// plus one of:
//
//   #open   — removes `hidden` from the element whose id is in `data-modal-toggle-id-value`
//   #close  — adds   `hidden` to that element
//   #stop   — stopPropagation, used on the modal content wrapper so clicks inside
//             don't bubble to a backdrop close handler
export default class extends Controller {
  static values = { id: String }

  open() {
    this._target()?.classList.remove("hidden")
  }

  close() {
    this._target()?.classList.add("hidden")
  }

  stop(event) {
    event.stopPropagation()
  }

  _target() {
    if (!this.hasIdValue) return null
    return document.getElementById(this.idValue)
  }
}
